import { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'clsx';
import PillButton from '../../components/shared/button/PillButton';
import {
  SUBSCRIBE_UNAVAILABLE_IN_REGION,
  SUBSCRIBE_UNAVAILABLE_CONTINUE_BROWSING,
} from '../../constants/localizations/subscription';
import { HOME_BROWSE_PATH } from '../../constants/paths';
import { LocationAndLocalizationContext } from '../../providers/LocationAndLocalizationProvider';
import css from './premium-not-available.module.scss';

const PremiumNotAvailable = ({
  className,
  headerClassName,
  buttonClassName,
  history,
}) => {
  const { getLocalizedText } = useContext(LocationAndLocalizationContext);

  return (
    <div data-testid="premiumNotAvailable" className={className}>
      <h1 className={classNames(headerClassName, css.h1)}>
        {getLocalizedText(SUBSCRIBE_UNAVAILABLE_IN_REGION)}
      </h1>
      <div className={classNames(buttonClassName, css.buttonWrapper)}>
        <PillButton
          id="continueBrowsing"
          label={getLocalizedText(SUBSCRIBE_UNAVAILABLE_CONTINUE_BROWSING)}
          className={css.button}
          onClick={() => history.push(HOME_BROWSE_PATH)}
        />
      </div>
    </div>
  );
};

PremiumNotAvailable.propTypes = {
  className: PropTypes.string,
  headerClassName: PropTypes.string,
  buttonClassName: PropTypes.string,
  history: PropTypes.object.isRequired,
};

export default PremiumNotAvailable;
